"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _selectedCharacteristics = require("../../actions/campaignCreator/selectedCharacteristics");

var _FilterLabel = _interopRequireDefault(require("../CampaignCreator/FilterLabel"));

var _TagList = _interopRequireDefault(require("./TagList"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var CharacteristicsFilterTagList = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CharacteristicsFilterTagList, _React$Component);

  function CharacteristicsFilterTagList() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = CharacteristicsFilterTagList.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        selectedCharacteristics = _this$props.selectedCharacteristics,
        removeSelectedCharacteristic = _this$props.removeSelectedCharacteristic;

    if (!selectedCharacteristics || selectedCharacteristics.characteristics.length <= 0) {
      return '';
    }

    return /*#__PURE__*/React.createElement(_TagList["default"], null, selectedCharacteristics && selectedCharacteristics.characteristics.map(function (characteristic, key) {
      return /*#__PURE__*/React.createElement(_FilterLabel["default"], {
        handleClick: function handleClick() {
          return removeSelectedCharacteristic(characteristic);
        },
        title: characteristic.answerLabel,
        key: key
      });
    }));
  };

  return CharacteristicsFilterTagList;
}(React.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    selectedCharacteristics: state.selectedCharacteristics
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    removeSelectedCharacteristic: _selectedCharacteristics.removeSelectedCharacteristic
  }, dispatch);
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CharacteristicsFilterTagList);

exports["default"] = _default;